module.exports = __webpack_public_path__ + "static/media/locations.e3514f3a.jpg";